export const normalizeNameForNamespace = (input: string): string =>
  input.replace(/@/g, '').replace(/-/g, '_').replace(/[\\/]/g, '.')
